import { useState, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Grid, IconButton, Button, Typography, CircularProgress } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

import * as HrActions from '../../../../../store/actions/hr.action';
import { getHrState } from '../../../../../store/selector/hr.selector';
import Services from '../../../../services';
import DownloadModal from '../../../ui/modal/download-modal';
import { IDownloadModal } from '../../../../interfaces/modal.interface';

const ReasonsList = () => {
  /* eslint-disable camelcase */
  const dispatch = useDispatch();

  const {
    reports_query,
    is_loading_dashboard_list,
    dashboard_list: {
      ApplicationsReport: {
        ReasonBreakdown: { breakdown },
      },
    },
  } = useSelector(getHrState);

  const [modalOptions, setModalOptions] = useState<IDownloadModal>({
    open: false,
    heading: 'Applications List',
    query: '',
  });

  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const searchReason = (e: string) => {
    const q = {
      ...reports_query,
      department: '',
      month: '',
      province: '',
      reason: e,
      signatory: '',
      status: '',
      year: '',
    };

    if (q) {
      dispatch(HrActions.DashboardApplicationData(q));
    }
  };

  const downloadReasonData = async () => {
    setIsDownloading(true);
    const { data, success, errors } = await Services.api.hr.applicationDashboardExport({
      ...reports_query,
      is_export: 'reason',
      department: '',
      month: '',
      province: '',
      reason: '',
      signatory: '',
      status: '',
      year: '',
    });

    if (success) {
      window.open(Services.api.hr.downloadApplicationDashboardData(data), '_blank');
      Services.toast('success', 'File successfully exported.');
      setIsDownloading(false);
    } else {
      const [{ message }] = errors;
      Services.toast('error', message);
      setIsDownloading(false);
    }
  };

  const toggleModal: (e?: string) => void = (e) => {
    setModalOptions((p) => ({
      ...p,
      open: !modalOptions.open,
      query: e || '',
    }));
  };

  return (
    <Box sx={{ background: '#fff', height: '70vh', width: '100%', overflowY: 'auto' }}>
      {is_loading_dashboard_list && Object.keys(breakdown).length === 0 ? (
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress color='primary' size={40} thickness={5} />

          <Typography sx={{ mt: '1rem' }}>Loading Reasons List</Typography>
        </Box>
      ) : (
        <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
          <Grid item xs={12} sx={{ mb: '2rem', display: 'flex', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: '1.5rem' }}>Reasons List</Typography>

            <IconButton
              onClick={() => {
                downloadReasonData();
              }}
              color='primary'
              sx={{ fontWeight: 'bold', p: is_loading_dashboard_list ? '0 1.2rem' : '0 1rem' }}
            >
              {isDownloading ? (
                <CircularProgress color='primary' size={15} thickness={5} />
              ) : (
                <DownloadIcon />
              )}
            </IconButton>
          </Grid>

          {Object.entries(breakdown).map(([k, v], i) => {
            return (
              <Fragment key={i}>
                <Grid item xs={10} sx={{ mt: i !== 0 ? '1rem' : 0 }}>
                  <Typography>{k}</Typography>
                </Grid>

                <Grid
                  item
                  xs={2}
                  sx={{ mt: i !== 0 ? '1rem' : 0, display: 'flex', justifyContent: 'center' }}
                >
                  <Button
                    onClick={() => {
                      toggleModal('applications');
                      searchReason(k);
                    }}
                    variant='text'
                    color='primary'
                    sx={{ fontWeight: 'bold', p: 0 }}
                  >
                    {v as number}
                  </Button>
                </Grid>
              </Fragment>
            );
          })}

          <DownloadModal onClose={toggleModal} options={modalOptions} />
        </Grid>
      )}
    </Box>
  );
};

export default ReasonsList;
